import { ToastProvider } from 'react-toast-notifications';
import React, { Fragment, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  createLimitAmountEntity,
  deleteLimitAmountEntity,
  updateLimitAmountEntity,
  findAll,
} from '../../redux/limitAmountEntity.duck';
import language from '../../config/es';
import { Row } from 'react-bootstrap';
import { es_decimal, es_vacio, es_entero } from '../../config/validate';
import { findByConcept } from '../../redux/type.duck';
import { findBySocieties } from '../../redux/collectingEntity.duck';
import { findSocieties } from '../../redux/society.duck';
import app from '../../config/application';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  createFormState,
  addFieldError,
  renderDeleteAction,
  requireSelection,
  requireValues,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlert,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
} from '../../components/Crud/CrudLayout';

const LimitAmountEntity = () => {
  const ref = useRef()
  const dispatch = useAppDispatch();
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
  } = useCrudState({
    ...createFormState({ editTransaction: true, pendingData: true }),
    id: null,
    collectionEntity: { value: 0, label: '', error: '', auth: '' },
    society: { value: 0, label: '', error: '', auth: '' },
    limitAmountEntity: [],
    responseCreate: [],
    responseEdit: [],
    responseView: [],
    dataRows: [],
    showloadingSociety: false,
    showloadingEntity: true,
    showloadingMoney: false,
    table: true,
    listMoney: [],
    money: { value: 0, label: '', error: '' },
    societies: [],
    messageMoney: '',
    currency: { value: '', error: '' },
    collectingEntity: { label: '', value: 0, error: '' },
    minAmount: { value: '', error: '' },
    maxAmount: { value: '', error: '' },
    entities: [],
    auth: JSON.parse(sessionStorage.getItem('user')),
    error: '',
    response: '',
    responseDelete: '',
  });
  data.responseDelete = useSelector(
    (store) => store.limitAmountEntityReducer.deleteLimitAmountEntity
  );

  data.response = useSelector(
    (store) => store.limitAmountEntityReducer.createLimitAmountEntity
  );
  data.limitAmountEntity = useSelector(
    (store) => store.limitAmountEntityReducer.limitAmountEntity
  );
  data.error = useSelector(
    (store) => store.limitAmountEntityReducer.limitError
  );
  data.societies = useSelector((store) => store.societyReducer.societies);
  data.entities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  data.listMoney = useSelector((store) => store.typeReducer.types);

  useEffect(() => {
    void responseDelete();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.responseDelete]);

  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.error]);
  useEffect(() => {
    void responseAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.response]);
  useEffect(() => {
    data.showloadingMoney = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.listMoney]);
  useCrudLifecycle(ref, data, () => {
    //loadLimitAmountEntityData();
    void loadSocieties();
    void loadTypes();
    data.pendingData = false;
    refreshState();
  });
  const responseDelete = async () => {
    if (!es_vacio(data.responseDelete) && data.responseDelete !== null) {
      viewNotification(language.messages.msmDisableAll, 'success');
    }
  };
  const responseAction = async () => {
    if (!es_vacio(data.response) && data.response !== null) {
      viewNotification(
        language.messages.msmRegister.replace(
          '{0}',
          data.response.minAmount + ' - ' + data.response.maxAmount
        ),
        'success'
      );
    }
  };
  const messageError = () => {
    if (data.error !== '') {
      viewNotification(data.error.error, 'error');
    }
  };

  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    data.showloadingSociety = true;
    refreshState();
  };
  const initTable = () => {
    const formatter = new Intl.NumberFormat('de-DE');
    data.columns = [
      buildEditColumn(handleButtonEdit, { width: '40px', idKey: 'Id' }),
      {
        name: language.messages.limitAmount.lblMinAmount,
        sortable: false,
        wrap: true,
        width: '30%',
        right: true,
        cell: (row) => (
          <div className="text-uppercase text-end">
            {formatter.format(Number.parseFloat(row.minAmount).toFixed(4))}
          </div>
        ),
      },
      {
        name: language.messages.limitAmount.lblMaxAmount,
        sortable: false,
        wrap: true,
        width: '30%',
        right: true,
        cell: (row) => (
          <div className=" text-uppercase text-end">
            {formatter.format(Number.parseFloat(row.maxAmount).toFixed(4))}
          </div>
        ),
      },
      {
        name: language.messages.titleMoney,
        sortable: false,
        wrap: true,
        width: '20%',
        cell: (row) => (
          <div className="text-primary small text-uppercase">
            {row.currency.code}
          </div>
        ),
      },
    ];
    updateState(data.columns, 'columns');
  };
  const loadLimitsAmount = async () => {
    data.pendingData = true;
    data.enable = false;
    updateState(true, 'pendingData');
    await dispatch(
      findAll(
        data.auth.id.user.username,
        data.collectingEntity.value,
        data.society.value
      )
    );
    initTable();
    data.pendingData = false;
    data.enable = true;
    refreshState();
  };
  const handleButtonEdit = (row) => {
    data.id = row.id;
    data.minAmount.value = row.minAmount;
    data.maxAmount.value = row.maxAmount;
    data.money.value = row.currency.id;
    data.money.label = row.currency.name;
    updateState(row.id, 'id');
  };

  const handleDelete = () => {
    void disableData();
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      initStateDelete(false);

      await dispatch(deleteLimitAmountEntity(data.selectedRows,data.auth.id.user.username));
      reloadData();
      initStateDelete(true);
    }
  };

  const contextActions = renderDeleteAction(handleDelete, data.enable);
  const handleSelectChange = async (value) => {
    data.collectingEntity = value;
    data.messageMoney = language.messages.messageSelectMoney;
    await loadLimitsAmount();
  };
  const saveData = async () => {
    validate();
    if (data.errors.length === 0) {
      data.enable = false;
      data.pendingData = true;
      refreshState();
      let json = {
        id: data.id,
        entity: { id: data.collectingEntity.value },
        currency: { id: data.currency.value },
        minAmount: data.minAmount.value,
        maxAmount: data.maxAmount.value,
        status: 1,
        userAdmin: data.auth.id.user.username,
        societyId: data.society.value,
      };

      if (data.id === null) {
        await dispatch(
          createLimitAmountEntity(json, data.auth.id.user.username)
        );
      } else {
        await dispatch(
          updateLimitAmountEntity(json, data.auth.id.user.username)
        );
      }
      data.pendingData = false;
      data.enable = true;
      init();
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
  };
  const validate = () => {
    clearError();
    requireSelection(data, ['society']);
    if (data.collectingEntity.value === 0) {
      addFieldError(
        data,
        'collectingEntity',
        language.messages.error_no_selected,
        'collectionEntity'
      );
    }
    requireSelection(data, ['money']);

    requireValues(data, ['minAmount', 'maxAmount', 'collectingEntity']);
    if (!es_entero(data.minAmount.value)) {
      if (!es_decimal(data.minAmount.value)) {
        data.errors.push('minAmount.error');
        data.minAmount.error = language.messages.warningOnlyNumericOrDecimal;
      }
    }
    if (!es_entero(data.maxAmount.value)) {
      if (!es_decimal(data.maxAmount.value)) {
        data.errors.push('maxAmount.error');
        data.maxAmount.error = language.messages.warningOnlyNumericOrDecimal;
      }
    }
    if (Number.parseFloat(data.maxAmount.value) < Number.parseFloat(data.minAmount.value)) {
      data.errors.push('maxAmount.error');
      data.maxAmount.error = language.messages.limitAmount.error.maxValue;
    }
    refreshState();
  };
  const clearError = () => {
    data.errors = [];
    data.minAmount.error = '';
    data.maxAmount.error = '';
    data.collectingEntity.error = '';
    data.money.error = '';
    data.society.error = '';
  };
  const init = () => {
    clearForm();
    void loadLimitsAmount();
  };
  const clearForm = () => {
    data.editType = true;
    data.id = null;
    data.minAmount = { value: '', label: '' };
    data.maxAmount = { value: '', label: '' };
    data.money = { value: 0, label: '', error: '' };
  };
  const onChange = (event) => {
    switch (event.target.name) {
      case 'collectingEntity':
        data.collectingEntity.value = event.target.value;
        data.collectingEntity.error = '';
        break;
      case 'minAmount':
        data.minAmount.value = event.target.value;
        data.minAmount.error = '';
        break;
      case 'maxAmount':
        data.maxAmount.value = event.target.value;
        data.maxAmount.error = '';
        break;
      default:
        break;
    }
    refreshState();
  };
  const cleaningForm = () => {
    clearError();
    clearForm();
    refreshState();
  };

  const reloadData = () => {
    void loadLimitsAmount();
  };
  const loadEntities = async () => {
    data.showloadingEntity = false;
    await dispatch(findBySocieties(data.society.value));
    updateState(true, 'showloadingEntity');
  };
  const updateSelect = async (value, id) => {
    switch (id) {
      case 'society':
        data.society = value;
        data.collectingEntity = { value: 0, label: '', error: '', auth: '' };
        data.dataRows = [];
        updateState(false, 'showloadingEntity');
        await loadEntities();
        data.showloadingEntity = true;
        break;
      case 'money':
        data.money = value;
        data.currency.value = data.money.value;
        data.messageMoney = '';
        break;
      default:
        break;
    }
    refreshState();
  };
  const loadTypes = async () => {
    await dispatch(findByConcept(app.data.types.currency));
  };
  return (
    <Fragment>
    <SessionConfig ref={ref}/>
      <CrudPage
        top={<br />}
        formCol={{ md: 5, xl: 4 }}
        formTitle={language.messages.limitAmount.titleAmountEntityForm}
        form={
          <form autoComplete="off">
            <RequiredFieldsAlert />
            <SelectField
              label={language.messages.society.title_society}
              loading={data.showloadingSociety}
              isDisabled={data.id !== null}
              name="society"
              options={data.societies}
              className="text-uppercase small "
              field={data.society}
              onChange={updateSelect}
              changeKey="society"
            />
            <SelectField
              label={language.messages.titleCEntityForm}
              loading={data.showloadingEntity}
              isDisabled={data.id !== null}
              name="classType"
              options={data.entities}
              className="text-uppercase small "
              field={data.collectingEntity}
              errorPosition="after"
              onChange={handleSelectChange}
            />

            <SelectField
              label={language.messages.titleMoney}
              loading={data.showloadingMoney}
              name="money"
              options={data.listMoney}
              className="text-uppercase small "
              field={data.money}
              errorPosition="afterDiv"
              onChange={updateSelect}
              changeKey="money"
            />
            <Row>
              <TextField
                col={{}}
                label={language.messages.limitAmount.lblMinAmount}
                name="minAmount"
                field={data.minAmount}
                onChange={onChange}
              />
              <TextField
                col={{}}
                label={language.messages.limitAmount.lblMaxAmount}
                name="maxAmount"
                field={data.maxAmount}
                onChange={onChange}
              />
            </Row>

            <CrudButtons
              withLoading
              wrapped
              enable={data.enable}
              isNew={data.id === null}
              onSave={saveData}
              onClear={cleaningForm}
              onReload={reloadData}
            />
          </form>
        }
        tableCol={{ md: 7, xl: 5 }}
        tableClassTitle=" text-uppercase text-capitalize"
        tableIcon="fa fa-list"
        tableTitle={language.messages.limitAmount.gridAmountEntityTitle}
        table={
          <CrudDataTable
            data={data}
            show={data.table}
            noHeader={es_vacio(data.collectingEntity.label)}
            title={
              <Fragment>
                <div className="small">
                  {data.collectingEntity.label}
                </div>
                <div className="font-size-11  text-primary">
                  {data.society.label}
                </div>
              </Fragment>
            }
            rows={data.limitAmountEntity}
            onSelect={handleSelectRow}
            pointerOnHover={true}
            actions={contextActions}
          />
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <LimitAmountEntity />
  </ToastProvider>
);
export default App;
